import styled, { keyframes } from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

const floatingLabel = keyframes`
    from {
        font-size: 14px;
        top: 29px;
        opacity: 0%;
    }
    to {
        font-size: 11.5px;
        top: 6px;
        opacity: 100%;
    }
`;
export const Label = styled.label`
  font-family: ${FONT_FAMILY.hellix.regular};
  z-index: 1;
  font-size: 14px !important;
  color: ${COLORS.textGrey};
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 1px;
  animation-name: ${floatingLabel};
  animation-duration: 0.3s;
  text-transform: none;
  animation-fill-mode: forwards;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
  ::first-letter {
    text-transform: uppercase;
  }
  &.text-visible-label {
    left: 18px;
    animation-name: unset;
  }
  &.label-error {
    color: ${COLORS.newerror};
  }
  margin-top: ${({ $marginTop }) => ($marginTop ? $marginTop : 0)};
`;

export const Wrapper = styled.div`
         margin: 15px 0 0 0;
         position: relative;
         ${(p) => p.$toggleFeature && `width: 110%;`}
         &&& {
           ${(p) =>
             p.$noDropdownIcon &&
             `.ui.disabled.dropdown, .ui.dropdown .menu>.disabled.item{
        opacity: 1;`}
        }
           &&&.currency-field .common-dropdown-wrapper, .currency-field-us-flow .common-dropdown-wrapper {
             margin-left: -6px;
           }
         }
         .ui.selection.active.dropdown .menu {
          background: ${COLORS.white};
          border: none;
          box-sizing: border-box;
          border-radius: 3px;
          box-shadow: 0px 2px 5px rgba(144, 144, 144, 0.4);
          overflow-y:auto;
          margin-top: 2px;
         }
         .ui.dropdown .menu>.item:hover {
          background: rgba(72, 249, 254, 0.4);
          box-sizing: border-box;
          }
          .ui.selection.active.dropdown .menu::-webkit-scrollbar-track {
            background-color: transparent;
            -webkit-box-shadow: none;
            border-radius: 0px;
          }
          
          .ui.selection.active.dropdown .menu::-webkit-scrollbar {
            width: 8px;
            height: 8px;
            background-color: transparent;
          }
          
          .ui.selection.active.dropdown .menu::-webkit-scrollbar-thumb {
            border-radius: 20px;
            height: 50px;
            border: 2px solid;
            border-color: transparent;
            background-clip: padding-box;
            -webkit-border-radius: 20px;
            box-shadow:none;
            -webkit-box-shadow: none;
            background-color: ${COLORS.borderGrey};
          }
       `;
export const TextWrapper = styled.div`
  margin: 15px 0 0 0;
  position: relative;
  > label {
    color: #46aeee;
  }
`;
